import React from 'react'
import i18next from 'i18next'
import MinimumQuantity from '../../../components/minimum-quantity/MinimumQuantity'
import { isBelowMinimum } from '../../../utils/minimumQuantity'
import QuantityInput from '../../quantity-input/QuantityInput'
import { IProduct } from '../../../types/products'
import { imageUrl } from '../../../utils/imageUrl'
import { setCartQuantity } from '../../../utils/cart'
import { handleImageFallback } from '../../../utils/brand'
import { useAppType } from '../../../context/AppContext'
import { productName } from '../../menu-item/MenuItem'
import './CartItem.scss'

type Props = {
  data: IProduct
  setCart: React.Dispatch<React.SetStateAction<IProduct[]>>
}
const c = 'cart-item'

const CartItem = ({ data, setCart }: Props) => {
  const appType = useAppType()
  const quantity = data?.quantity ?? 1

  const setQuantity = (next: number | ((prev: number) => number)) => {
    const value = typeof next === 'function' ? next(quantity) : next
    setCart((prev) => setCartQuantity(prev, data._id, value))
  }

  return (
    <div className={`${c}${isBelowMinimum(data) ? ' minimum-quantity-invalid' : ''}`}>
      <img
        className={`${c}__image`}
        src={imageUrl(data?.image, 128)}
        alt=''
        loading='lazy'
        decoding='async'
        onError={handleImageFallback(appType)}
      />
      <div className={`${c}__info`}>
        <div className={`${c}__title`}>{productName(data)}</div>
        {data?.selectedIngredients && data.selectedIngredients.length > 0 && (
          <div className={`${c}__ingredients`}>
            {data.selectedIngredients.map((ing) => (
              <span key={ing._id}>
                +
                {i18next.language === 'ru' && ing.label_ru
                  ? ing.label_ru
                  : ing.label}
              </span>
            ))}
          </div>
        )}
        <div className={`${c}__row`}>
          <QuantityInput
            quantity={quantity}
            setQuantity={setQuantity}
            cartItem
            size='sm'
          />
          <div className={`${c}__price`}>
            {Number(data?.price) * quantity} lei
          </div>
        </div>
        {isBelowMinimum(data) && <MinimumQuantity product={data} invalid compact />}
      </div>
    </div>
  )
}

export default CartItem
